import Velocity from 'velocity-animate'

export function scrollTo (element, offset = 0, callback) {
  if (typeof offset !== 'number') {
    callback = offset
    offset = 0
  }

  Velocity(element, 'scroll', {
    duration: 500,
    offset,
    easing: 'ease-in-out',
    complete: callback
  })
}

export function scrollToTop (callback) {
  if (window.scrollY === 0) {
    if (typeof callback === 'function') {
      callback()
    }

    return
  }

  const $body = document.querySelector('body')
  scrollTo($body, callback)
}

export function isMobileDevice () {
  return typeof window.orientation !== `undefined`
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js